import { constructApplications, constructRoutes, constructLayoutEngine, } from "single-spa-layout";
import microfrontendLayout from "./microfrontend-layout.html";
import 'vuejs-noty/dist/vuejs-noty.css';
import { initRootApplication } from "./core/app";
const { bootstrap, start } = initRootApplication();
const routes = constructRoutes(microfrontendLayout);
const applications = constructApplications({
    routes,
    loadApp({ name }) {
        return System.import(name);
    },
});
const layoutEngine = constructLayoutEngine({ routes, applications });
bootstrap().then((context) => {
    layoutEngine.activate();
    start(context);
});
